import { Outlet } from "react-router-dom";
import { SubNav } from "./PrideParts";

export default function PrideLayout() {
  return (
    <div className="pt-[74px]">
      <SubNav />
      <Outlet />
    </div>
  );
}
